var React = require('react');

function HeaderBg (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"パス_1885","data-name":"パス 1885","d":"M4248.831,71.653s-810.142,1048-2348,1048-2348-1048-2348-1048Z","transform":"translate(447.169 -71.653)","fill":"#c0b57c"}));
}

HeaderBg.defaultProps = {"width":"4696","height":"1048","viewBox":"0 0 4696 1048"};

module.exports = HeaderBg;

HeaderBg.default = HeaderBg;
